import t from './actionTypes'

const lessonsPickerActions = {

	toggleLesson(entityUID) {
		return {
			type: t.PICKER_LESSON_TOGGLE,
			entityUID,
		}
	},

	updateSearchQuery(search) {
		return {
			type: t.PICKER_UPDATE_SEARCH_QUERY,
			search,
		}
	},

	applySearchQuery() {
		return {
			type: t.PICKER_APPLY_SEARCH_QUERY,
		}
	},

	updateSort(order_field, order_type) {
		return {
			type: t.PICKER_UPDATE_SORT,
			order_field,
			order_type,
		}
	},

	resetPickerSearch(search) {
		return {
			type: t.PICKER_RESET_SEARCH,
			search,
		}
	},

	toggleShowAll() {
		return {
			type: t.PICKER_TOGGLE_SHOW_ALL,
		}
	},

	end() {
		return {
			type: t.PICKER_END,
		}
	},

}

export default lessonsPickerActions
